/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import Toggle from 'react-toggle';
import Alert from 'react-s-alert';
import { MultiSelect } from 'react-multi-select-component';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const Clients = props => {

    // variables
    let timeout = 0;

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [isLoading3, setIsLoading3] = useState(false);
    const [clients, setClients] = useState([]);
    const [modal, setModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [confirmationModal, setConfirmationModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });
    const [isCopied, setIsCopied] = useState(false);

    const [customEmailModal, setCustomEmailModal] = useState({ isVisible: false });
    const [customEmailClientList, setCustomEmailClientList] = useState([]);
    const [selectedCustomRecipients, setselectedCustomRecipients] = useState([]);
    const [selectedCustomClients, setSelectedCustomClients] = useState([]);
    const [customEmailSubject, setCustomEmailSubject] = useState('');
    const [customEmailBody, setCustomEmailBody] = useState('');
    const [customEmailMsgPreview, setCustomEmailMsgPreview] = useState('');


    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects

    // setup label and values for custom email modal
    useEffect(() => {
        let tempArray = [];
        for (let i = 0; i < clients.length; i++) {
            tempArray[i] = {
                label: clients[i].email,
                value: clients[i].email
            }
        }
        setCustomEmailClientList(tempArray);
    }, [clients]);


    // update selected custom clients with client name when recipients changes
    useEffect(() => {
        let tempArray = [];
        tempArray = clients.filter((client) => selectedCustomRecipients.map((item) => item.value).includes(client.email));
        // console.log('tempArray', tempArray);
        let tempArray1 = [];
        for (let i = 0; i < tempArray.length; i++) {
            tempArray1[i] = {
                email: tempArray[i].email,
                name: tempArray[i].firstName + " " + tempArray[i].lastName
            }
        }
        // console.log('tempArray1', tempArray1);
        setSelectedCustomClients(tempArray1);
    }, [selectedCustomRecipients]);

    // set custom email msg preview
    useEffect(() => {
        let tempData =
            `Dear ${selectedCustomClients.map((item) => item.name)},
    
${customEmailBody}

Yours Sincerely,
Umang Wellness Support
`

        setCustomEmailMsgPreview(tempData);
    }, [selectedCustomClients, selectedCustomRecipients, customEmailSubject, customEmailBody]);


    // update copy
    useEffect(() => {
        setIsCopied(false);
    }, [selectedCustomRecipients]);



    useEffect(() => {
        if (!isLoading2) {
            setIsLoading2(true);
            AdminService.getClients(pagination.limit, pagination.page, pagination.searchVal).then(data => {
                try {
                    // console.log('data', data.clients);
                    setClients(data.clients);
                    if (data.pagination.totalPages <= data.pagination.page) {
                        data.pagination.page = data.pagination.totalPages;
                    }
                    setPagination(data.pagination);
                    setIsLoading2(false);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at Admin Clients useEffect', 'Error in try catch block', err.stack);
                    setIsLoading2(false);
                }
            });
        }
    }, [pagination.page, pagination.limit, pagination.searchVal]);

    // handle functions

    // handle onChange of Custom Email
    const handleOnChangeCustomEmail = val => {
        setselectedCustomRecipients(val);
        // console.log(selectedCustomRecipients);
    }

    // handle onChange customEmailSubject
    const handleCustomEmailSubject = e => {
        setCustomEmailSubject(e.target.value)
    }

    // handle onChange customEmailBody
    const handleCustomEmailBody = e => {
        setCustomEmailBody(e.target.value);
    }

    const handleSearch = e => {
        try {
            let value = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, searchVal: value });
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handleSerach', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            // if(e.target.id === "limit"){
            //     const value = e.target.value;
            //     setTimeout(() => {
            //         setPagination({...pagination, limit: value});
            //     }, 500);
            // }
            // else
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handlePagination', 'Error in try catch block', err.stack);
        }
    }

    const handleToggleChange = (index) => {
        try {
            let tempClients = [...clients];
            tempClients[index].isActive = !tempClients[index].isActive;
            setClients(tempClients);
            AdminService.setActiveStatusClient(tempClients[index]._id, tempClients[index].isActive)
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setConfirmationModal({ isVisible: false, selectedIndex: -1 });
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handleToggleChange', 'Error in try catch block', err.stack);
        }
    }

    //utility functions
    // send Custom Email helper function
    const sendCustomEmail = e => {
        e.preventDefault();
        setIsLoading(true);

        let dataToSend = {
            selectedCustomRecipients: selectedCustomClients,
            customEmailSubject: customEmailSubject,
            customEmailBody: customEmailBody
        }
        AdminService.sendCustomEmail(dataToSend)
            .then(data => {
                try {
                    setCustomEmailModal({ visible: false });
                    setIsLoading(false);
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setCustomEmailSubject('');
                    setCustomEmailBody('');
                    setselectedCustomRecipients([]);
                    setSelectedCustomClients([]);
                    setIsCopied(false);
                } catch (err) {
                    setIsLoading(false);
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at Admin Clients sendCustomEmail', 'Error in try catch block', err.stack);
                }
            })
            .catch(error => {
                setIsLoading(false);
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
            })
    }

    const copyBCCString = () => {
        navigator.clipboard.writeText(selectedCustomRecipients.map((item) => item.value).join(", "));
        setIsCopied(true);
    }

    const showDetails = (index) => {
        try {
            setModal({ isVisible: true, selectedIndex: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients showDetails', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <div className="d-flex my-4">
                    <h3 className="my-auto">Clients</h3>
                    <Button className="btn ml-auto" style={theme.button} onClick={() => setCustomEmailModal({ isVisible: true })}>Custom Email</Button>
                </div>
                <div className="card mb-4">
                    <div className="card-header">
                        Client List
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <td colSpan="6" className="border-0 px-0">
                                            <div className="d-flex">
                                                <div className="ml-auto">
                                                    Search<input type="text" id="searchInput" className="ml-2" style={{ marginRight: "-20px", paddingRight: "20px" }} onChange={handleSearch}></input>
                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("searchInput").value = ""; setPagination({ ...pagination, searchVal: "" }); }}><i className="fa fa-times"></i></span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Unique id</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Counsellor Allocated</th>
                                        <th align="center" style={{ width: '185px' }}>Activate / Deactivate</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        clients.map((item, index) => (
                                            <ErrorBoundary errorAt={`At Admin Clients Table${index}`}>
                                                <tr key={index}>
                                                    <td>{item._id}</td>
                                                    <td>{item.title ? item.title : ''} {item.firstName} {item.lastName}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.selectedProvider.provider ? `${item.selectedProvider.provider.title ? item.selectedProvider.provider.title : ''} ${item.selectedProvider.provider.firstName} ${item.selectedProvider.provider.lastName}` : "-"}</td>
                                                    <td align="center"><Toggle icons={false} checked={item.isActive} onChange={() => setConfirmationModal({ isVisible: true, selectedIndex: index })} /></td>
                                                    <td align="center"><a style={{ color: "#384E73" }} href="#" onClick={() => showDetails(index)}>View details</a></td>
                                                </tr>
                                            </ErrorBoundary>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="6" className="border-0 pb-0 px-0">
                                            <div className="d-flex">
                                                {/* <div className="d-flex p-2">
                                                    <span>Showing {pagination.totalResults==0 ? 0 : 1 } to</span>
                                                    <Input style={{width:'47px', height: '30px', padding: '14px 5px', margin: '0 5px'}} id="limit" minLength="1" maxLength="4" name="limit" value={pagination.limit>pagination.totalResults ? pagination.totalResults : pagination.limit} onChange={e => handlePagination(e,null)} ></Input>
                                                    <span>of {pagination.totalResults} entries</span>
                                                </div> */}
                                                <ErrorBoundary errorAt="At Admin Clients Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


            <Modal size="lg" isOpen={customEmailModal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => { setCustomEmailModal({ isVisible: false }); setCustomEmailSubject(''); setCustomEmailBody(''); setselectedCustomRecipients([]); setSelectedCustomClients([]); setIsCopied(false); }}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Custom Email</span></ModalHeader>

                <ModalBody>
                    <Form onSubmit={sendCustomEmail}>

                        <FormGroup>
                            <Label style={theme.formBodyText} >Select Clients to send Email</Label>
                            <MultiSelect
                                onChange={handleOnChangeCustomEmail}
                                options={customEmailClientList}
                                value={selectedCustomRecipients}
                                labelledBy={"Select"}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>BCC String</Label>
                            <div className="d-flex">

                                <Input type="text" value={selectedCustomRecipients.map((item) => item.value).join(", ")} className="form-control" style={theme.formInput} disabled />
                                <Button color="success" onClick={copyBCCString}>{isCopied ? "Copied!" : "Copy"}</Button>
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <Label style={theme.formBodyText} >Email Subject</Label>
                            <Input type="text" value={customEmailSubject} onChange={handleCustomEmailSubject} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <FormGroup>
                            <Label style={theme.formBodyText} >Email Body</Label>
                            <Input type="textarea" rows="10" value={customEmailBody} onChange={handleCustomEmailBody} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <FormGroup>
                            <Label style={theme.formBodyText} >Email Preview</Label>
                            <br />
                            <Label style={theme.formBodyText} >Recipients : {selectedCustomClients.map((item) => item.email).join(", ")}</Label>
                            <Input type="textarea" rows="12" className="form-control" style={theme.formInput} value={customEmailMsgPreview} disabled required />
                        </FormGroup>

                        <Button type="submit" style={theme.formButton} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Send</Button>
                    </Form>

                </ModalBody>
            </Modal>

            <ErrorBoundary errorAt="At Admin Clients ConfirmationModal">
                <Modal size="sm" isOpen={confirmationModal.isVisible} backdrop={true}>
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setConfirmationModal({ isVisible: false, selectedIndex: -1 })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Are you sure?</span></ModalHeader>
                    <ModalBody>
                        {
                            confirmationModal.selectedIndex >= 0 ?
                                <Label>By clicking on Save button <b>{clients[confirmationModal.selectedIndex].email}</b> will be <b>{clients[confirmationModal.selectedIndex].isActive ? "Deactivated" : "Activated"}</b> and will be notified via email about this.</Label>
                                : null
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={() => handleToggleChange(confirmationModal.selectedIndex)} disabled={isLoading3}>
                            {isLoading3 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Save
                        </Button>
                    </ModalFooter>
                </Modal>
            </ErrorBoundary>
            <ErrorBoundary errorAt="At Admin Clients Modal">
                <Modal size="lg" isOpen={modal.isVisible} backdrop={true}>
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false, selectedIndex: -1 })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Data</span></ModalHeader>
                    <ModalBody>
                        {
                            modal.selectedIndex >= 0 ?
                                <div id="modalBody">
                                    <p><span style={{ fontWeight: "600" }}>Name:</span><span className="ml-1">{clients[modal.selectedIndex].title} {clients[modal.selectedIndex].firstName} {clients[modal.selectedIndex].lastName}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Email:</span><span className="ml-1">{clients[modal.selectedIndex].email}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>isActive:</span><span className="ml-1">{clients[modal.selectedIndex].isActive ? "Yes" : "No"}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Birthdate:</span><span className="ml-1">{clients[modal.selectedIndex].birthDate}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Gender:</span><span className="ml-1">{clients[modal.selectedIndex].gender}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Phone:</span><span className="ml-1">{clients[modal.selectedIndex].phone}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Selected Counsellor:</span><span className="ml-1">{clients[modal.selectedIndex].selectedProvider.provider ? `${clients[modal.selectedIndex].selectedProvider.provider.title} ${clients[modal.selectedIndex].selectedProvider.provider.firstName} ${clients[modal.selectedIndex].selectedProvider.provider.lastName}` : null}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Address1:</span><span className="ml-1">{clients[modal.selectedIndex].address1}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Address2:</span><span className="ml-1">{clients[modal.selectedIndex].address2}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>City:</span><span className="ml-1">{clients[modal.selectedIndex].city}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>State:</span><span className="ml-1">{clients[modal.selectedIndex].state}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Country:</span><span className="ml-1">{clients[modal.selectedIndex].country}</span></p>
                                    <p><span style={{ fontWeight: "600" }}>Pincode:</span><span className="ml-1">{clients[modal.selectedIndex].pincode}</span></p>
                                </div> : null
                        }
                    </ModalBody>
                </Modal>
            </ErrorBoundary>
        </main>
    )

}

export default Clients;